import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServiceSection from './components/ServiceSection';
import AdvantageSection from './components/AdvantageSection';
import NewsSection from './components/NewsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  useEffect(() => {
    document.title = '开云官网 - 官方正版入口，安全登录体验';
  }, []);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '开云官网',
            url: 'https://www.kaiyun.com',
            description: '开云官网是您访问开云平台的官方正版渠道，提供安全稳定的登录入口、丰富的产品服务与极致用户体验。',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://www.kaiyun.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '开云官网首页',
            description: '开云官网是您访问开云平台的官方正版渠道。',
            isPartOf: {
              '@type': 'WebSite',
              name: '开云官网',
              url: 'https://www.kaiyun.com',
            },
          }),
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <ServiceSection />
          <AdvantageSection />
          <NewsSection />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}